import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import LumbreApp from './views/LumbreApp'

import /* webpackChunkName: "LmRouterView" */ LmRouterView from '@/components/LmRouterView'
import /* webpackChunkName: "LmList" */ LmList from '@/components/LmList'
import /* webpackChunkName: "LmListV2" */ LmListV2 from '@/components/LmListV2'
import /* webpackChunkName: "LmFormBuilder" */ LmFormBuilder from '@/components/LmFormBuilder.vue'
import /* webpackChunkName: "LmFormBuilderUi" */ LmFormBuilderUi from '@/views/LmFormBuilderUi.vue'
import /* webpackChunkName: "LmListBuilder" */ LmListBuilder from '@/views/LmListBuilder.vue'
import /* webpackChunkName: "NewOrEdit" */ NewOrEdit from '@/views/coupons/NewOrEdit'
import /* webpackChunkName: "calendar" */ DashboardHome from '@/views/dashboard/DashboardHome'
import /* webpackChunkName: "LmNewOrEdit" */ LmNewOrEdit from '@/components/LmNewOrEdit'
import /* webpackChunkName: "LmDashboard" */ LmDashboard from '@/components/LmDashboard.vue'
import /* webpackChunkName: "LmDocumentTypesNewOrEdit" */ LmDocumentTypesNewOrEdit from '@/views/LmDocumentTypesNewOrEdit.vue'
import /* webpackChunkName: "LmDocumentsNewOrEdit" */ LmDocumentsNewOrEdit from '@/views/LmDocumentsNewOrEdit.vue'
import /* webpackChunkName: "LmWidgetsBuilder" */ LmWidgetsBuilder from '@/views/LmWidgetsBuilder.vue'
import /* webpackChunkName: "LmCodificatorsBuilderNewOrEdit" */ LmCodificatorsBuilderNewOrEdit from '@/views/LmCodificatorsBuilderNewOrEdit.vue'
import /* webpackChunkName: "LmCodificatorsNewOrEdit" */ LmCodificatorsNewOrEdit from '@/views/LmCodificatorsNewOrEdit.vue'
import /* webpackChunkName: "LmMenuBuilderNewOrEdit" */ LmMenuBuilderNewOrEdit from '@/views/LmMenuBuilderNewOrEdit.vue'

// XXX: Estas views que se importan son temporales y solo aplican para MVL Mesa3 en un futuro
// van a dejar de cargarse en lumbre y van a pasar a ser componentes

// MESA
import /* webpackChunkName: "MesaUserProfile" */ MesaUserProfile from '@/views/mvlmesa/usuarios/MesaUserProfile'
import /* webpackChunkName: "MesaLicencias" */ MesaLicencias from '@/views/mvlmesa/licencias/MesaLicencias'
import /* webpackChunkName: "ExpedientesNewOrEdit" */ ExpedientesNewOrEdit from '@/views/mvlmesa/expedientes/ExpedientesNewOrEdit'
import /* webpackChunkName: "NotasNewOrEdit" */ NotasNewOrEdit from '@/views/mvlmesa/expedientes/NotasNewOrEdit'
import /* webpackChunkName: "ArchivoNewOrEdit" */ ArchivoNewOrEdit from '@/views/mvlmesa/expedientes/ArchivoNewOrEdit'
import /* webpackChunkName: "RemitosNewOrEdit" */ RemitosNewOrEdit from '@/views/mvlmesa/remitos/RemitosNewOrEdit'
import /* webpackChunkName: "RemitosDetalle" */ RemitosDetalle from '@/views/mvlmesa/remitos/RemitosDetalle'
import /* webpackChunkName: "RemitosConfirmar" */ RemitosConfirmar from '@/views/mvlmesa/remitos/RemitosConfirmar'
import /* webpackChunkName: "PasesNewOrEdit" */ PasesNewOrEdit from '@/views/mvlmesa/pases/PasesNewOrEdit'
import /* webpackChunkName: "PasesAnular" */ PasesAnular from '@/views/mvlmesa/pases/PasesAnular'
import /* webpackChunkName: "PasesInternosAsignar" */ PasesInternosAsignar from '@/views/mvlmesa/pasesinternos/PasesInternosAsignar'
import /* webpackChunkName: "PasesInternosCerrar" */ PasesInternosCerrar from '@/views/mvlmesa/pasesinternos/PasesInternosCerrar'
import /* webpackChunkName: "PasesInternosAnular" */ PasesInternosAnular from '@/views/mvlmesa/pasesinternos/PasesInternosAnular'
import /* webpackChunkName: "DocumentosNewOrEdit" */ DocumentosNewOrEdit from '@/views/mvlmesa/documentos/DocumentosNewOrEdit'
import /* webpackChunkName: "DocumentosAsociadosNewOrEdit" */ DocumentosAsociadosNewOrEdit from '@/views/mvlmesa/documentos/DocumentosAsociadosNewOrEdit'
import /* webpackChunkName: "DocumentoAFirmarNewOrEdit" */ DocumentoAFirmarNewOrEdit from '@/views/mvlmesa/documentos/DocumentoAFirmarNewOrEdit'
import /* webpackChunkName: "CaratulaExpediente" */ CaratulaExpediente from '@/views/mvlmesa/documentos/CaratulaExpediente'
import /* webpackChunkName: "GireseExpediente" */ GireseExpediente from '@/views/mvlmesa/documentos/GireseExpediente'
import /* webpackChunkName: "TemplateNewOrEdit" */ TemplateNewOrEdit from '@/views/mvlmesa/templates/TemplateNewOrEdit'
import /* webpackChunkName: "DecretosNewOrEdit" */ DecretosNewOrEdit from '@/views/mvlmesa/decretos/DecretosNewOrEdit'
import /* webpackChunkName: "DecretosMovements" */ DecretosMovements from '@/views/mvlmesa/decretos/DecretosMovements'
import /* webpackChunkName: "DecretosFirmar" */ DecretosFirmar from '@/views/mvlmesa/decretos/DecretosFirmar'
import /* webpackChunkName: "UsuariosNewOrEdit" */ UsuariosNewOrEdit from '@/views/mvlmesa/usuarios/UsuariosNewOrEdit'
import /* webpackChunkName: "NotificacionesNewOrEdit" */ NotificacionesNewOrEdit from '@/views/mvlmesa/notificaciones/NotificacionesNewOrEdit'
import /* webpackChunkName: "NotificacionesNewOrEditDemo" */ NotificacionesNewOrEditDemo from '@/views/demo/notificaciones/NotificacionesNewOrEditDemo'
import /* webpackChunkName: "MesaDelegacionesConsultas" */ MesaDelegacionesConsultas from '@/views/mvlmesa/delegaciones/MesaDelegacionesConsultas'
import /* webpackChunkName: "MesaDelegacionesTramiteNewOrEdit" */ MesaDelegacionesTramiteNewOrEdit from '@/views/mvlmesa/delegaciones/MesaDelegacionesTramiteNewOrEdit'
import /* webpackChunkName: "MesaDelegacionesVecinoNewOrEdit" */ MesaDelegacionesVecinoNewOrEdit from '@/views/mvlmesa/delegaciones/MesaDelegacionesVecinoNewOrEdit'

import /* webpackChunkName: "MesaObrasCopiaDePlanoNewOrEdit" */ MesaObrasCopiaDePlanoNewOrEdit from '@/views/mvlmesa/obras/MesaObrasCopiaDePlanoNewOrEdit'
import /* webpackChunkName: "MesaObrasCopiaDePlanosConsultas" */ MesaObrasCopiaDePlanosConsultas from '@/views/mvlmesa/obras/MesaObrasCopiaDePlanosConsultas'
import /* webpackChunkName: "MesaObrasCopiaDePlanoPaseNewOrEdit" */ MesaObrasCopiaDePlanoPaseNewOrEdit from '@/views/mvlmesa/obras/MesaObrasCopiaDePlanoPaseNewOrEdit'
import /* webpackChunkName: "MesaObrasVisadoParcelarioNewOrEdit" */ MesaObrasVisadoParcelarioNewOrEdit from '@/views/mvlmesa/obras/MesaObrasVisadoParcelarioNewOrEdit'
import /* webpackChunkName: "MesaObrasVisadoParcelarioPaseNewOrEdit" */ MesaObrasVisadoParcelarioPaseNewOrEdit from '@/views/mvlmesa/obras/MesaObrasVisadoParcelarioPaseNewOrEdit'
import /* webpackChunkName: "MesaObrasVisadoParcelarioConsultas" */ MesaObrasVisadoParcelarioConsultas from '@/views/mvlmesa/obras/MesaObrasVisadoParcelarioConsultas'
import /* webpackChunkName: "MesaObrasVisadoPrevioNewOrEdit" */ MesaObrasVisadoPrevioNewOrEdit from '@/views/mvlmesa/obras/MesaObrasVisadoPrevioNewOrEdit'
import /* webpackChunkName: "MesaObrasVisadoPrevioConsultas" */ MesaObrasVisadoPrevioConsultas from '@/views/mvlmesa/obras/MesaObrasVisadoPrevioConsultas'
import /* webpackChunkName: "MesaObrasVisadoPrevioPaseNewOrEdit" */ MesaObrasVisadoPrevioPaseNewOrEdit from '@/views/mvlmesa/obras/MesaObrasVisadoPrevioPaseNewOrEdit'
// Visado Apto Final
import /* webpackChunkName: "MesaObrasVisadoAptoFinalNewOrEdit" */ MesaObrasVisadoAptoFinalNewOrEdit from '@/views/mvlmesa/obras/MesaObrasVisadoAptoFinalNewOrEdit'
import /* webpackChunkName: "MesaObrasGenericConsultasVecino" */ MesaObrasGenericConsultasVecino from '@/views/mvlmesa/obras/MesaObrasGenericConsultasVecino'
import /* webpackChunkName: "MesaObrasGenericPaseNewOrEdit" */ MesaObrasGenericPaseNewOrEdit from '@/views/mvlmesa/obras/MesaObrasGenericPaseNewOrEdit'

// CEMENTERIO

// 365
import /* webpackChunkName: "PreciosVigentesNewOrEdit" */ PreciosVigentesNewOrEdit from '@/views/365/pages/PreciosVigentesNewOrEdit.vue'
import /* webpackChunkName: "PreciosVigentesNewOrEdit" */ HomeNewOrEdit from '@/views/365/pages/HomeNewOrEdit.vue'
import /* webpackChunkName: "SorteosNewOrEdit" */ SorteosNewOrEdit from '@/views/365/pages/SorteosNewOrEdit.vue'
import /* webpackChunkName: "SorteosNewOrEdit" */ SorteosOptionsNewOrEdit from '@/views/365/pages/SorteosOptionsNewOrEdit.vue'
import /* webpackChunkName: "NomenclaturasDetail" */ NomenclaturasDetail from '@/views/mvlcementerio/nomenclaturas/NomenclaturasDetail'
import /* webpackChunkName: "LandingPagesNewOrEdit" */ LandingPagesNewOrEdit from '@/views/365/landings/LandingPagesNewOrEdit.vue'
import /* webpackChunkName: "SlidersNewOrEdit" */ SlidersNewOrEdit from '@/views/365/sliders/SlidersNewOrEdit.vue'

// UCASAL
import /* webpackChunkName: "ResolucionesNewOrEdit" */ ResolucionesNewOrEdit from '@/views/ucasal/resoluciones/ResolucionesNewOrEdit'
import /* webpackChunkName: "ResolucionesFirmar" */ ResolucionesFirmar from '@/views/ucasal/resoluciones/ResolucionesFirmar'
import /* webpackChunkName: "ResolucionesHistorial" */ ResolucionesHistorial from '@/views/ucasal/resoluciones/ResolucionesHistorial'

// MVLSENTENCIAS
import /* webpackChunkName: "SentenciasNewOrEdit" */ SentenciasNewOrEdit from '@/views/mvlsentencias/sentencias/SentenciasNewOrEdit'
import /* webpackChunkName: "SentenciasFirmar" */ SentenciasFirmar from '@/views/mvlsentencias/sentencias/SentenciasFirmar'
import /* webpackChunkName: "SentenciasHistorial" */ SentenciasHistorial from '@/views/mvlsentencias/sentencias/SentenciasHistorial'

// LumbreSign
import /* webpackChunkName: "DocumentWithSectionsNewOrEdit" */ DocumentWithSectionsNewOrEdit from '@/views/lumbresign/documentWithSections/DocumentWithSectionsNewOrEdit'
import /* webpackChunkName: "DocumentSimpleNewOrEdit" */ DocumentSimpleNewOrEdit from '@/views/lumbresign/documentSimple/DocumentSimpleNewOrEdit'
import /* webpackChunkName: "DocumentWithSectionsHistorical" */ DocumentWithSectionsHistorical from '@/views/lumbresign/DocumentWithSectionsHistorical'
import /* webpackChunkName: "DocumentsLmListV1" */ DocumentsLmListV1 from '@/views/lumbresign/DocumentsLmListV1'

// https://github.com/lumile/lumbre/issues/604
// Credits: https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
const b64DecodeUnicode = function (str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

const vueComponents = {
  LmRouterView,
  LmList,
  LmListV2,
  LmFormBuilderUi,
  LmFormBuilder,
  LmListBuilder,
  NewOrEdit,
  MesaUserProfile,
  MesaLicencias,
  ExpedientesNewOrEdit,
  NotasNewOrEdit,
  ArchivoNewOrEdit,
  RemitosNewOrEdit,
  RemitosDetalle,
  RemitosConfirmar,
  PasesNewOrEdit,
  PasesAnular,
  PasesInternosAsignar,
  PasesInternosCerrar,
  PasesInternosAnular,
  DocumentosNewOrEdit,
  DocumentosAsociadosNewOrEdit,
  DocumentoAFirmarNewOrEdit,
  CaratulaExpediente,
  GireseExpediente,
  TemplateNewOrEdit,
  DecretosNewOrEdit,
  DecretosMovements,
  DecretosFirmar,
  UsuariosNewOrEdit,
  NotificacionesNewOrEdit,
  NotificacionesNewOrEditDemo,
  NomenclaturasDetail,
  DashboardHome,
  LmDashboard,
  LmNewOrEdit,
  PreciosVigentesNewOrEdit,
  HomeNewOrEdit,
  SorteosNewOrEdit,
  SorteosOptionsNewOrEdit,
  LandingPagesNewOrEdit,
  LmDocumentTypesNewOrEdit,
  LmDocumentsNewOrEdit,
  LmWidgetsBuilder,
  LmCodificatorsBuilderNewOrEdit,
  LmCodificatorsNewOrEdit,
  LmMenuBuilderNewOrEdit,
  // Delegaciones - MVL
  MesaDelegacionesConsultas,
  MesaDelegacionesTramiteNewOrEdit,
  MesaDelegacionesVecinoNewOrEdit,
  // Copia de Planos - MVL
  MesaObrasCopiaDePlanoNewOrEdit,
  MesaObrasCopiaDePlanosConsultas,
  MesaObrasCopiaDePlanoPaseNewOrEdit,
  // Visado Parcelario - MVL
  MesaObrasVisadoParcelarioPaseNewOrEdit,
  MesaObrasVisadoParcelarioNewOrEdit,
  MesaObrasVisadoParcelarioConsultas,
  // Visado Previo - MVL
  MesaObrasVisadoPrevioNewOrEdit,
  MesaObrasVisadoPrevioConsultas,
  MesaObrasVisadoPrevioPaseNewOrEdit,

  // Visado Apto Final - MVL
  MesaObrasVisadoAptoFinalNewOrEdit,
  MesaObrasGenericConsultasVecino,
  MesaObrasGenericPaseNewOrEdit,
  // UCASAL
  ResolucionesNewOrEdit,
  ResolucionesFirmar,
  ResolucionesHistorial,
  // MVLSENTENCIAS
  SentenciasNewOrEdit,
  SentenciasFirmar,
  SentenciasHistorial,
  // LumbreSign
  DocumentWithSectionsNewOrEdit,
  DocumentSimpleNewOrEdit,
  DocumentWithSectionsHistorical,
  DocumentsLmListV1,
  // Slider principal 365 web
  SlidersNewOrEdit
}

Vue.use(Router)

class MetaBreadcrumb {
  constructor (name, to) {
    this.name = name
    this.to = to
  }
}

export async function createRouter () {
  const routerConfig = {
    mode: 'history',
    routes: [
      {
        path: '/',
        component: LumbreApp,
        meta: {
          breadcrumb: new MetaBreadcrumb('Dashboard', '/')
        },
        children: [
          {
            path: '',
            name: 'dashboard_home',
            meta: {
              title: 'Dashboard'
            },
            component: () => import(/* webpackChunkName: "calendar" */ '@/views/dashboard/DashboardHome.vue')
          },
          {
            path: 'inbox',
            name: 'inbox',
            meta: {
              title: 'Bandeja de Entrada'
            },
            component: () => import(/* webpackChunkName: "inbox" */ '@/views/LmInbox.vue')
          },
          {
            path: '/form',
            name: 'form',
            meta: {
              title: 'Fom'
            },
            component: () => import(/* webpackChunkName: "form" */ '@/views/Form.vue')
          },
          {
            path: '/formbuilderui',
            name: 'FormBuilderUi',
            meta: {
              title: 'FormBuilderUi'
            },
            redirect: process.env.VUE_APP_ENABLE_FORMBUILDERUI === 'no' ? '404' : null,
            component: () => import(/* webpackChunkName: "LmFormBuilderUi" */ '@/views/LmFormBuilderUi.vue')
          },
          {
            path: '/formbuilderui/edit/:id',
            name: 'FormBuilderUi-edit',
            props: {
              isOnEditMode: true
            },
            meta: {
              title: 'FormBuilderUi'
            },
            redirect: process.env.VUE_APP_ENABLE_FORMBUILDERUI === 'no' ? '404' : null,
            component: () => import(/* webpackChunkName: "LmFormBuilderUi" */ '@/views/LmFormBuilderUi.vue')
          },
          {
            path: '/formBuilderUi/preview/:idFormBuilder/:id?',
            name: 'FormBuilderUi-preview',
            meta: {
              title: 'LmFormBuilderPreview.vue'
            },
            component: () => import(/* webpackChunkName: "LmFormBuilderPreview" */ '@/views/LmFormBuilderPreview.vue')
          },
          {
            path: '/formBuilderUi/preview-custom/:idFormBuilder/:id?',
            name: 'FormBuilderUi-previewCustom',
            meta: {
              title: 'LmFormBuilderCustomPreview.vue'
            },
            component: () => import(/* webpackChunkName: "LmFormBuilderCustomPreview" */ '@/views/LmFormBuilderCustomPreview.vue')
          },
          {
            path: '/listFormBuilder',
            name: 'FormBuildlistFormBuildererUi',
            meta: {
              title: 'listFormBuilder'
            },
            props: {
              // listEndpointUri: `${menuBaseSlugName}/listado/todos`, // Esta es la ruta de la api desde la cual se van a obtener los pases a mostrar
              isGraphql: true,
              gqlField: 'formbuilderLmListV2',
              gqlQuery: `query($page:Int, $q:String, $sort:[FormbuilderESSortEnum]) {
  formbuilderLmListV2(
    titleList: "Listado de Formularios",
    q:$q,
    perPage: 10
    page: $page
    sort: $sort
    opts: {
      lenient: true
    }
    lmPathActions: [
      {
        to: "/FormBuilderUi/edit/:_id",
        tooltip: "Editar",
        fontAwesomeIcon: "edit"
      },
      {
        to: "/FormBuilderUi/preview/:_id",
        tooltip: "Previsualizar",
        fontAwesomeIcon: "eye"
      }
    ]
    buttonLinks: [
      {
        value: "Nuevo Formulario"
        to: "/formBuilderUi/"
      }
    ]
  ) {
    count
    searcher
    tableItemsTotal
    titleList
    filter {
      aggregatesToSelect
    }
    pagination
    initialOrderBy
    order
    itemsPerPage
    table {
      items {
        pageTitleData
        createdAt
        updatedAt
        actions
      }
      fields {
        key
        label
        sortable
      }
    }
    buttons
  }
}`,
              gqlVariables: {
                q: '*',
                sort: '_score',
                page: 1
              },

              component: () => import(/* webpackChunkName: "FormBuilderUi" */ '@/components/LmListV2.vue')
            },
            component: () => import(/* webpackChunkName: "FormBuilderUi" */ '@/components/LmListV2.vue')
          },
          {
            path: '/listbuilder',
            name: 'ListBuilderUi',
            meta: {
              title: 'listBuilderUi',
              conditionalRoute: process.env.VUE_APP_ENABLE_LISTBUILDER,
              pathConditionalRoute: '/'
            },
            props: {
              // listEndpointUri: `${menuBaseSlugName}/listado/todos`, // Esta es la ruta de la api desde la cual se van a obtener los pases a mostrar
              isGraphql: true,
              gqlField: 'formbuilderLmListV2',
              gqlQuery: `query($page:Int, $q:String, $sort:[FormbuilderESSortEnum]) {
  formbuilderLmListV2(
    titleList: "Listado de Formularios",
    q:$q,
    perPage: 10
    page: $page
    sort: $sort
    opts: {
      lenient: true
    }
    lmPathActions: [
      {
        to: "/FormBuilderUi/edit/:_id",
        tooltip: "Editar",
        fontAwesomeIcon: "edit"
      },
      {
        to: "/FormBuilderUi/preview/:_id",
        tooltip: "Previsualizar",
        fontAwesomeIcon: "eye"
      }
    ]
    buttonLinks: [
      {
        value: "Nuevo Formulario"
        to: "/formBuilderUi/"
      }
    ]
  ) {
    count
    searcher
    tableItemsTotal
    titleList
    filter {
      aggregatesToSelect
    }
    pagination
    initialOrderBy
    order
    itemsPerPage
    table {
      items {
        pageTitleData
        createdAt
        updatedAt
        actions
      }
      fields {
        key
        label
        sortable
      }
    }
    buttons
  }
}`,
              gqlVariables: {
                q: '*',
                sort: '_score',
                page: 1
              },

              gqlSchema: `query schemaGraphql {
 __schema {
    queryType {
      name
      fields {
        name
        type {
          name
          fields{
            name
            type{
              name
              fields{
                name
                type{
                  name
                  ofType{
                name
                    fields{
                      name
                    }
                  }
                }
              }
            }
          }
        }
        args {
        type {
          name
          ofType {
            name
            kind
            inputFields{
              name
              description
            }
            enumValues{
              name
            }
            }
        }
          }
      }
    }
  }
}`,

              component: () => import('@/views/LmListBuilder.vue')
            },
            component: () => import('@/views/LmListBuilder.vue')
          },
          {
            path: '/listbuilder/edit/:id',
            name: 'Listbuilder-edit',
            meta: {
              title: 'listBuilderEdit',
              conditionalRoute: process.env.VUE_APP_ENABLE_LISTBUILDER,
              pathConditionalRoute: '/'
            },
            props: {
              // listEndpointUri: `${menuBaseSlugName}/listado/todos`, // Esta es la ruta de la api desde la cual se van a obtener los pases a mostrar
              isOnEditMode: true,
              isGraphql: true,
              gqlField: 'formbuilderLmListV2',
              gqlQuery: `query($page:Int, $q:String, $sort:[FormbuilderESSortEnum]) {
  formbuilderLmListV2(
    titleList: "Listado de Formularios",
    q:$q,
    perPage: 10
    page: $page
    sort: $sort
    opts: {
      lenient: true
    }
    lmPathActions: [
      {
        to: "/FormBuilderUi/edit/:_id",
        tooltip: "Editar",
        fontAwesomeIcon: "edit"
      },
      {
        to: "/FormBuilderUi/preview/:_id",
        tooltip: "Previsualizar",
        fontAwesomeIcon: "eye"
      }
    ]
    buttonLinks: [
      {
        value: "Nuevo Formulario"
        to: "/formBuilderUi/"
      }
    ]
  ) {
    count
    searcher
    tableItemsTotal
    titleList
    filter {
      aggregatesToSelect
    }
    pagination
    initialOrderBy
    order
    itemsPerPage
    table {
      items {
        pageTitleData
        createdAt
        updatedAt
        actions
      }
      fields {
        key
        label
        sortable
      }
    }
    buttons
  }
}`,
              gqlVariables: {
                q: '*',
                sort: '_score',
                page: 1
              },

              gqlSchema: `query schemaGraphql {
 __schema {
    queryType {
      name
      fields {
        name
        type {
          name
          fields{
            name
            type{
              name
              fields{
                name
                type{
                  name
                  ofType{
                name
                    fields{
                      name
                    }
                  }
                }
              }
            }
          }
        }
        args {
        type {
          name
          ofType {
            name
            kind
            inputFields{
              name
              description
            }
            enumValues{
              name
            }
            }
        }
          }
      }
    }
  }
}`,

              component: () => import('@/views/LmListBuilder.vue')
            },
            component: () => import('@/views/LmListBuilder.vue')
          },
          {
            path: '/listbuilder/view/:id',
            name: 'Listbuilder-view',
            component: () => import(/* webpackChunkName: "listbuilder" */ '@/views/LmListBuilderView.vue')
          },
          {
            path: '/refactored-expedientes-form',
            name: 'newExpedientesNewOrEdit',
            meta: {
              title: 'refactoredExpedientesNewOrEdit'
            },
            component: () => import(/* webpackChunkName: "refactored" */ '@/views/mvlmesa/expedientes/refactoredExpedientesNewOrEdit.vue')
          },
          {
            path: '/draggable',
            name: 'draggable',
            meta: {
              title: 'draggable'
            },
            component: () => import(/* webpackChunkName: "refactored" */ '@/views/mvlmesa/draggable/index.vue')
          }
        ]
      },
      {
        path: '/login',
        name: 'login',
        meta: {
          title: 'Login'
        },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
      },
      {
        path: '/callback',
        name: 'callback',
        component: () => import(/* webpackChunkName: "callback" */ '@/views/Callback.vue')
      },
      {
        path: '/no-permitido',
        name: '401',
        component: () => import(/* webpackChunkName: "404" */ '@/views/401.vue')
      },
      {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue')
      }
    ]
  }

  // Se cargan las rutas dinamicamente desde el endpoint de la API
  try {
    const apiResponse = await axios.get('settings/routesconfig/')
    // Si en la respuesta el valor `h` está seteado a true el valor de routesConfigs esta
    // encodeado en base64
    if (apiResponse?.data?.h === true) {
      let decodedRoutes = apiResponse.data.routesConfigs.split(':')
      decodedRoutes = b64DecodeUnicode(decodedRoutes[1])
      apiResponse.data.routesConfigs = JSON.parse(decodedRoutes)
    }
    if (Array.isArray(apiResponse?.data?.routesConfigs)) {
      let useCustomUserProfileRoute = false
      apiResponse.data.routesConfigs.forEach(newRoute => {
        if (newRoute.component in vueComponents) {
          newRoute.component = vueComponents[newRoute.component]
          // Si el endpoint nos retorna una ruta con name 'user-profile'
          // la usamos en vez del user-profile por defecto de lumbre
          if (newRoute?.name === 'user-profile') {
            useCustomUserProfileRoute = true
          }
          if (newRoute?.meta?.breadcrumb) {
            newRoute.meta.breadcrumb = new MetaBreadcrumb(newRoute.meta.breadcrumb)
          }
          if (Array.isArray(newRoute?.children)) {
            newRoute.children = newRoute.children.map(child => {
              child.component = vueComponents[child.component]
              return child
            })
          }
          routerConfig.routes[0].children.push(newRoute)
        }
      })
      if (!useCustomUserProfileRoute) {
        // Si la api no definio ninguna pagina de perfil usamos una generica.
        routerConfig.routes[0].children.push({
          path: '/user-profile',
          name: 'user-profile',
          component: () => import(/* webpackChunkName: "user-profile" */ '@/views/LmUserProfile.vue')
        })
      }
    }
    // Si se requiere "restablecer contraseña"
    if (process.env?.VUE_APP_ENABLE_FORGOT_PASSWORD) {
      routerConfig.routes.push({
        path: '/restore-password',
        name: 'restore-password',
        component: () => import(/* webpackChunkName: "restore-password" */ '@/views/restorePassword.vue')
      })
    }
  } catch (error) {
    console.log(error)
  }

  return new Router(routerConfig)
}
